import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { JsonHttpService } from "src/app/shared/http/json-http.service";
import { Sequence } from "../models/sequence";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SequencesService {

    constructor(private httpService: JsonHttpService) {
    }

    // Sequences
    getSequences(): Promise<Sequence[]> {
        return this.httpService.get('/api/sequences/get-sequences').toPromise();
    }

    deleteSequence(id: number, useGenericErrorHandling: (err: any, caught: Observable<any>) => boolean = _ => true): Promise<void> {
        const options = { params: new HttpParams().set('sequenceId', id) };
        return this.httpService.postWithErrorEval('/api/sequences/delete-sequence', null, options, useGenericErrorHandling).toPromise();
    }

    saveSequence(entity: Sequence, useGenericErrorHandling: boolean): Promise<Sequence> {
        return this.httpService.post('/api/sequences/save-sequence', entity, undefined, useGenericErrorHandling).toPromise();
    }
}